<template>
  <header
    :class="classList" v-bind:style="$user.type==1?changeTheme:changeTheme2">
    <slot>Header</slot>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data () {
    return {
      changeTheme:{
        color: 'white',
      },
      changeTheme2:{
        color: 'white',
        backgroundColor:'rebeccapurple'
      }
    }
  },
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classList () {
      return [
        'app-header',
        'navbar'
      ]
    }
  },
  mounted: function () {
    this.isFixed(this.fixed)
  },
  methods: {
    isFixed (fixed) {
      fixed ? document.body.classList.add('header-fixed') : document.body.classList.remove('header-fixed')
      return fixed
    }
  }
}
</script>
